import { useEffect, useRef, useState } from "react";
import { uploadConteudoImage } from "../../../../../../services/conteudosApi";
import { sourceImage } from "../../../../../../utils/source-image";
import { BUTTON_RESET, INPUT } from "../../../../../../styles";

const TOOLBAR_BUTTON = {
  ...BUTTON_RESET,
  minWidth: 34,
  height: 34,
  borderRadius: 10,
  border: "1px solid #D7E3EA",
  background: "#FFFFFF",
  color: "#24323F",
  fontSize: 13,
  fontWeight: 800,
  display: "grid",
  placeItems: "center",
};

const TOOLBAR_GROUP = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  paddingRight: 8,
  marginRight: 2,
  borderRight: "1px solid #E2E8F0",
};

function ToolbarIcon({ children }) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: 16,
        height: 16,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </span>
  );
}

function IconBold() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <path
          d="M5 3.5H8.6C10.24 3.5 11.5 4.5 11.5 5.9C11.5 6.9 10.88 7.7 9.92 8C11.14 8.24 12 9.18 12 10.44C12 12 10.64 13 8.84 13H5V3.5ZM6.7 7.28H8.4C9.3 7.28 9.82 6.78 9.82 6.06C9.82 5.34 9.3 4.84 8.4 4.84H6.7V7.28ZM6.7 11.66H8.68C9.72 11.66 10.3 11.12 10.3 10.28C10.3 9.42 9.68 8.84 8.64 8.84H6.7V11.66Z"
          fill="currentColor"
        />
      </svg>
    </ToolbarIcon>
  );
}

function IconItalic() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <path
          d="M6 3.5H11"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M5 12.5H10"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M9.5 3.5L6.5 12.5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </ToolbarIcon>
  );
}

function IconUnderline() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <path
          d="M5 3.5V8.2C5 9.94 6.34 11.3 8 11.3C9.66 11.3 11 9.94 11 8.2V3.5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M4 13H12"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </ToolbarIcon>
  );
}

function IconBullets() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <circle cx="3" cy="4" r="1.2" fill="currentColor" />
        <circle cx="3" cy="8" r="1.2" fill="currentColor" />
        <circle cx="3" cy="12" r="1.2" fill="currentColor" />
        <path
          d="M6 4H13"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M6 8H13"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M6 12H13"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </ToolbarIcon>
  );
}

function IconNumbers() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <path
          d="M2.4 4H4.1V8"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.2 8H4.4"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <path
          d="M6 4H13"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M6 8H13"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M2.5 11.3C2.9 10.9 3.3 10.7 3.8 10.7C4.5 10.7 5 11.12 5 11.76C5 12.18 4.78 12.56 4.38 12.96L2.6 14.6H5.2"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12H13"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </ToolbarIcon>
  );
}

function IconLink() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <path
          d="M6.2 9.8L9.8 6.2"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M6.1 6.8L4.7 8.2C3.67 9.23 3.67 10.9 4.7 11.93C5.73 12.97 7.4 12.97 8.43 11.93L9.8 10.56"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M9.9 9.2L11.3 7.8C12.33 6.77 12.33 5.1 11.3 4.07C10.27 3.03 8.6 3.03 7.57 4.07L6.2 5.44"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </ToolbarIcon>
  );
}

function IconImage() {
  return (
    <ToolbarIcon>
      <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
        <rect
          x="2.2"
          y="3"
          width="11.6"
          height="10"
          rx="1.8"
          stroke="currentColor"
          strokeWidth="1.4"
        />
        <circle cx="5.4" cy="6.2" r="1.1" fill="currentColor" />
        <path
          d="M3.8 11L6.8 8.4C7.14 8.1 7.64 8.11 7.96 8.42L9.1 9.52C9.4 9.8 9.85 9.84 10.18 9.6L11.8 8.4L12.2 11"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </ToolbarIcon>
  );
}

export function RichTextEditor({ value, onChange, placeholder }) {
  const editorRef = useRef(null);
  const imageInputRef = useRef(null);
  const selectionRef = useRef(null);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [uploadError, setUploadError] = useState("");

  useEffect(() => {
    const element = editorRef.current;

    if (!element) {
      return;
    }

    if (element.innerHTML !== (value || "")) {
      element.innerHTML = value || "";
    }
  }, [value]);

  const syncHtml = () => {
    if (!editorRef.current) {
      return;
    }

    onChange(editorRef.current.innerHTML);
  };

  const saveSelection = () => {
    const selection = window.getSelection();

    if (!selection || selection.rangeCount === 0 || !editorRef.current) {
      return;
    }

    const range = selection.getRangeAt(0);
    if (!editorRef.current.contains(range.commonAncestorContainer)) {
      return;
    }

    selectionRef.current = range.cloneRange();
  };

  const restoreSelection = () => {
    const selection = window.getSelection();

    if (!selection || !selectionRef.current) {
      return;
    }

    selection.removeAllRanges();
    selection.addRange(selectionRef.current);
  };

  const applyCommand = (command, commandValue = null) => {
    if (!editorRef.current) {
      return;
    }

    editorRef.current.focus();
    restoreSelection();
    document.execCommand(command, false, commandValue);
    syncHtml();
    saveSelection();
  };

  const handleInsertLink = () => {
    saveSelection();
    const url = window.prompt("Cole a URL do link:");

    if (!url) {
      return;
    }

    applyCommand("createLink", url.trim());
  };

  return (
    <div
      style={{
        border: "1px solid #D7E3EA",
        borderRadius: 14,
        overflow: "hidden",
        background: "#FFFFFF",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          padding: 10,
          borderBottom: "1px solid #E7EEF2",
          background: "#F8FAFC",
          alignItems: "center",
        }}
      >
        <div style={TOOLBAR_GROUP}>
          <select
            defaultValue="Arial"
            onChange={(event) => applyCommand("fontName", event.target.value)}
            style={{
              ...INPUT,
              width: 150,
              minHeight: 34,
              padding: "0 10px",
            }}
            title="Fonte"
          >
            <option value="Arial">Arial</option>
            <option value="Georgia">Georgia</option>
            <option value="Tahoma">Tahoma</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Verdana">Verdana</option>
          </select>

          <select
            defaultValue="p"
            onChange={(event) =>
              applyCommand("formatBlock", event.target.value)
            }
            style={{
              ...INPUT,
              width: 124,
              minHeight: 34,
              padding: "0 10px",
            }}
            title="Formato"
          >
            <option value="p">Texto</option>
            <option value="h1">Titulo 1</option>
            <option value="h2">Titulo 2</option>
            <option value="h3">Titulo 3</option>
          </select>
        </div>

        <div style={TOOLBAR_GROUP}>
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => applyCommand("bold")}
            style={TOOLBAR_BUTTON}
            title="Negrito"
          >
            <IconBold />
          </button>
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => applyCommand("italic")}
            style={TOOLBAR_BUTTON}
            title="Italico"
          >
            <IconItalic />
          </button>
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => applyCommand("underline")}
            style={TOOLBAR_BUTTON}
            title="Sublinhado"
          >
            <IconUnderline />
          </button>
        </div>

        <div style={TOOLBAR_GROUP}>
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => applyCommand("insertUnorderedList")}
            style={TOOLBAR_BUTTON}
            title="Lista"
          >
            <IconBullets />
          </button>
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => applyCommand("insertOrderedList")}
            style={TOOLBAR_BUTTON}
            title="Lista numerada"
          >
            <IconNumbers />
          </button>
        </div>

        <div style={TOOLBAR_GROUP}>
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={handleInsertLink}
            style={TOOLBAR_BUTTON}
            title="Inserir link"
          >
            <IconLink />
          </button>
          <label
            style={{
              ...TOOLBAR_BUTTON,
              cursor: "pointer",
            }}
            onMouseDown={(event) => {
              event.preventDefault();
              saveSelection();
            }}
            onClick={() => imageInputRef.current?.click()}
            title="Inserir imagem"
          >
            <IconImage />
          </label>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12, color: "#64748B", fontWeight: 700 }}>
            Cor
          </span>
          <input
            type="color"
            defaultValue="#24323f"
            onChange={(event) => applyCommand("foreColor", event.target.value)}
            style={{
              ...TOOLBAR_BUTTON,
              padding: 4,
              width: 42,
            }}
            title="Cor do texto"
          />
        </div>
      </div>

      <input
        ref={imageInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={async (event) => {
          const file = event.target.files?.[0];
          event.target.value = "";

          if (!file) {
            return;
          }

          setUploadError("");
          setIsUploadingImage(true);

          try {
            const response = await uploadConteudoImage(file);
            const imageUrl = sourceImage(response?.path || response?.url || "");

            if (!imageUrl) {
              throw new Error("A API nao retornou a URL da imagem.");
            }

            applyCommand("insertImage", imageUrl);
          } catch (error) {
            setUploadError(
              error?.response?.data?.message ||
                error?.message ||
                "Nao foi possivel enviar a imagem.",
            );
          } finally {
            setIsUploadingImage(false);
          }
        }}
      />

      {(isUploadingImage || uploadError) && (
        <div
          style={{
            padding: "10px 14px 0",
            fontSize: 12,
            color: uploadError ? "#B91C1C" : "#0F766E",
            fontWeight: 700,
          }}
        >
          {uploadError || "Enviando imagem..."}
        </div>
      )}

      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onInput={syncHtml}
        onMouseUp={saveSelection}
        onKeyUp={saveSelection}
        onBlur={saveSelection}
        className="rich-text-content"
        style={{
          minHeight: 180,
          padding: 14,
          outline: "none",
          fontSize: 14,
          lineHeight: 1.7,
          color: "#18212B",
        }}
        data-placeholder={placeholder}
      />

      {!value && (
        <div
          style={{
            marginTop: -180,
            minHeight: 180,
            padding: 14,
            pointerEvents: "none",
            color: "#94A3B8",
            fontSize: 14,
            lineHeight: 1.7,
          }}
        >
          {placeholder}
        </div>
      )}
    </div>
  );
}
